import React from 'react'
import FeatureNotImplemented from '../FeatureNotImplemented/FeatureNotImplemented'

const Data = () => {
  return (
    <div><FeatureNotImplemented msg="Data"/></div>
  )
}

export default Data